/** Helpers de dinero — todas las cifras viajan en céntimos por la red. */

const EUR_FMT = new Intl.NumberFormat('es-ES', {
  style: 'currency',
  currency: 'EUR',
  // es-ES no agrupa los números de cuatro cifras (1234,56 €) salvo que se le pida.
  useGrouping: true,
})

export function formatCents(cents: number | null | undefined): string {
  if (cents == null) return '—'
  return EUR_FMT.format(cents / 100)
}

/** Convierte un string del input ("12,50" o "12.50") a céntimos enteros. */
export function parseEurosToCents(input: string): number {
  if (!input.trim()) return 0
  const normalized = input.replace(/\s/g, '').replace(',', '.')
  const n = Number(normalized)
  if (!Number.isFinite(n)) return 0
  return Math.round(n * 100)
}

/** Convierte céntimos a string editable "12,50". */
export function centsToEurosInput(cents: number): string {
  if (!cents) return ''
  return (cents / 100).toFixed(2).replace('.', ',')
}
